import React from 'react';
import { useNavigation } from 'context/NavigationContext';
import { BringzzPageContainer, BringzzIcon , BringzzText, BringzzButton} from "@bringzz/components";

const AccountActivatedPage = () => {
  const { navigate } = useNavigation();

  return (
    <BringzzPageContainer
          className="bg-white"
          header={{
              left: (
                  <div onClick={() => navigate('/')} className='cursor-pointer'>
                      <BringzzIcon
                          size='22'
                          icon='IconClose'
                          folder='LineIcons'
                      />
                  </div>
              ),
              title: "Account Activated"
          }}
          authenticated={false}
          footer={<div className='pb-8 px-6'>
              <BringzzButton
                  size='lg'
                  className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                  onClick={() => navigate('/auth')} icon={undefined}>
                  Login
              </BringzzButton>
          </div>} steps={undefined} activeStep={undefined}    >
      <div className='relative flex justify-center bg-magic-lilac/20'>
        <div className='relative bg-white w-full bg-cover bg-center flex flex-col md:max-w-2xl '>

          <div className='flex-grow flex flex-col justify-between py-12 px-4'>
            <div className='z-10 flex flex-col '>
              <div className='flex flex-col space-y-6 mx-2 md:max-w-lg lg:max-w-xl xl:max-w-2xl'>
                <BringzzText tag='h1' className='pl-2 text-midnight-blue font-bold'>
                  Your account has been activated!
                </BringzzText>
                <BringzzText tag="h3" className="font-normal">
                  You can now log in to your account.
                </BringzzText>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BringzzPageContainer>
  );
};

export default AccountActivatedPage;